// 是否不是community版本
export const isNoCommunity = !(localStorage.getItem('version_code') === 'community');
